import React from 'react'

export default class RezCentral extends React.Component{
  //static apiURL = 'http://localhost:5000/api/scr/';
  //static apiKey = '1234';
  static apiURL = 'https://data-services-api.revlinkauto.com/api/scr/';
  static apiKey = '02e4c8f1-f8d2-46aa-be52-3acc5a1d5620';

  static getLocations(){
    return this.getData('locations', '');
  }

  static getRates(options){
    var body = {
      pickupLocationId : options.pickupLocationId,
      dropoffLocationid : options.dropoffLocationid,
      pickupDateTime : options.pickupDateTime,
      dropoffDateTime : options.dropoffDateTime,
      discountCode : options.discountCode,
      extras : options.extras
    };

    return this.postData('rates', body);
  }

  static getExtras(locationId){
    //console.log(locationId)
    if(typeof locationId === 'undefined' || locationId === '')
      return Promise.resolve({ data : { dailyExtras : []} });

    return this.getData('extras', 'locationId=' + locationId);
  }

  static getBill(options){
    //console.log("CALLING GET BILL");

    var body = {
      pickupLocationId : options.pickupLocationId,
      dropoffLocationId : options.dropoffLocationId,
      pickupDateTime : options.pickupDateTime,
      dropoffDateTime : options.dropoffDateTime,
      discountCode : options.discountCode,
      classCode : options.classCode,
      rateId : options.rateId,
      extras : options.extras
    };

    if(options.confirmationNum !== null)
      body.confirmationNum = options.confirmationNum;

    return this.postData('bill', body);
    //console.log('BODY')
    //console.log(body)
    //var self = this;
  }

  static addRez(options){
    console.log("CALLING ADD REZ");

    var body = {
      pickupLocationId : options.pickupLocationId,
      dropoffLocationId : options.dropoffLocationId,
      pickupDateTime : options.pickupDateTime,
      dropoffDateTime : options.dropoffDateTime,
      discountCode : options.discountCode,
      classCode : options.classCode,
      rateID : options.rateId,
      extras : options.extras,
      renterDob : options.renterDob,
      renterFirst : options.renterFirst,
      renterLast : options.renterLast,
      renterCellPhone : options.renterCellPhone,
      emailAddress : options.emailAddress,
      termsAndConditions : options.termsAndConditions
    };

    if(options.confirmationNum !== null)
      body.confirmationNum = options.confirmationNum;

    //console.log('BODY')
    //console.log(body)
    //var self = this;
    return this.postData('addRez', body);
  }

  static getRez(options){
    //console.log("CALLING GET REZ");

    var body = {
      confirmNum : options.confirmationNum
    };

    //console.log('BODY')
    //console.log(body)
    //var self = this;
    return this.postData('getRez', body);
  }

  static cancelRez(confirmationNum){
    var body = {
      confirmNum : confirmationNum
    };

    return this.postData('cancelRez', body);
  }

  static getData(path, query){
    var querystring = '';
    if(query !== null && query.length > 0){
      querystring = '?' + query;
    }
    return fetch(this.apiURL + path + querystring, {
      method : "GET",
      headers: {"Content-type": "application/json;charset=UTF-8;", "apiKey" : this.apiKey},
    })
    .then(response => response.json())
    .then(data => {
      return data;
    });
  }

  static postData(path, body){
    return fetch(this.apiURL + path, {
      method : "POST",
      headers: {"Content-type": "application/json;charset=UTF-8;", "apiKey" : this.apiKey},
      body : JSON.stringify(body)
    })
    .then(response => response.json())
    .then(data => {
      return data;
    });
  }
}
